"use client";

import { c as _c } from "react/compiler-runtime";
import { useCallback, useEffect, useState } from "react";
import { useEnsAddress, useEnsName } from "wagmi";
const LABEL_SEPARATOR = " - ";
type UseEnsResolutionOptions = Readonly<{
  initialValue?: string;
  chainId?: number;
}>;
export function useEnsResolution(t0) {
  const $ = _c(28);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const options = t1;
  const {
    initialValue: t2,
    chainId: t3
  } = options;
  const initialValue = t2 === undefined ? "" : t2;
  const chainId = t3 === undefined ? 1 : t3;
  const [inputValue, setInputValue] = useState(initialValue);
  const [resolvedAddress, setResolvedAddress] = useState(initialValue);
  let t4;
  let t5;
  if ($[2] !== initialValue) {
    t4 = () => {
      setInputValue(initialValue);
      setResolvedAddress(initialValue);
    };
    t5 = [initialValue];
    $[2] = initialValue;
    $[3] = t4;
    $[4] = t5;
  } else {
    t4 = $[3];
    t5 = $[4];
  }
  useEffect(t4, t5);
  let t6;
  if ($[5] !== inputValue) {
    t6 = inputValue?.startsWith("0x") ? inputValue as `0x${string}` : undefined;
    $[5] = inputValue;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== chainId || $[8] !== t6) {
    t7 = {
      address: t6,
      chainId
    };
    $[7] = chainId;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  const ensNameQuery = useEnsName(t7);
  let t8;
  if ($[10] !== inputValue) {
    t8 = inputValue?.endsWith(".eth") ? inputValue : undefined;
    $[10] = inputValue;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== chainId || $[13] !== t8) {
    t9 = {
      name: t8,
      chainId
    };
    $[12] = chainId;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  const ensAddressQuery = useEnsAddress(t9);
  let t10;
  let t11;
  if ($[15] !== ensNameQuery.data) {
    t10 = () => {
      const ensName = ensNameQuery.data;
      if (!ensName) {
        return;
      }
      let pendingAddress = null;
      setInputValue(current => {
        if (!current || current.includes(LABEL_SEPARATOR)) {
          return current;
        }
        if (!current.startsWith("0x")) {
          return current;
        }
        pendingAddress = current;
        return `${ensName}${LABEL_SEPARATOR}${current}`;
      });
      if (pendingAddress) {
        setResolvedAddress(pendingAddress);
      }
    };
    t11 = [ensNameQuery.data];
    $[15] = ensNameQuery.data;
    $[16] = t10;
    $[17] = t11;
  } else {
    t10 = $[16];
    t11 = $[17];
  }
  useEffect(t10, t11);
  let t12;
  let t13;
  if ($[18] !== ensAddressQuery.data) {
    t12 = () => {
      const resolvedAddressFromEns = ensAddressQuery.data;
      if (!resolvedAddressFromEns) {
        return;
      }
      setResolvedAddress(resolvedAddressFromEns);
      setInputValue(current_0 => normalizeInputWithResolvedAddress(current_0, resolvedAddressFromEns));
    };
    t13 = [ensAddressQuery.data];
    $[18] = ensAddressQuery.data;
    $[19] = t12;
    $[20] = t13;
  } else {
    t12 = $[19];
    t13 = $[20];
  }
  useEffect(t12, t13);
  let t14;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = value => {
      setInputValue(value);
      setResolvedAddress(value);
    };
    $[21] = t14;
  } else {
    t14 = $[21];
  }
  const handleInputChange = t14;
  let t15;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = value_0 => {
      setResolvedAddress(value_0);
    };
    $[22] = t15;
  } else {
    t15 = $[22];
  }
  const setAddress = t15;
  let t16;
  if ($[23] !== ensAddressQuery || $[24] !== ensNameQuery || $[25] !== inputValue || $[26] !== resolvedAddress) {
    t16 = {
      inputValue,
      address: resolvedAddress,
      setInputValue,
      setAddress,
      handleInputChange,
      ensNameQuery,
      ensAddressQuery
    };
    $[23] = ensAddressQuery;
    $[24] = ensNameQuery;
    $[25] = inputValue;
    $[26] = resolvedAddress;
    $[27] = t16;
  } else {
    t16 = $[27];
  }
  return t16;
}
function normalizeInputWithResolvedAddress(current: string, resolvedAddress: string): string {
  if (!current) {
    return resolvedAddress;
  }
  if (current.endsWith(`${LABEL_SEPARATOR}${resolvedAddress}`)) {
    return current;
  }
  const parts = current.split(LABEL_SEPARATOR);
  if (parts.length === 1) {
    return `${current}${LABEL_SEPARATOR}${resolvedAddress}`;
  }
  const lastIndex = parts.length - 1;
  if (parts[lastIndex]?.toLowerCase()?.startsWith("0x")) {
    parts[lastIndex] = resolvedAddress;
    return parts.join(LABEL_SEPARATOR);
  }
  return `${current}${LABEL_SEPARATOR}${resolvedAddress}`;
}